// eslint-disable-next-line
const apiHost = process.browser ? process.env.apiHostBrowser : process.env.apiHostServer;
// eslint-disable-next-line
const apiPath = process.env.apiPath;

export const GET_INSPIRATIONS_TREE = `${apiHost}${apiPath}menu?tree_type=inspirations`;
export const GET_PRODUCT_TREE = `${apiHost}${apiPath}menu`;
export const GET_FORUM_TREE = `${apiHost}${apiPath}menu?tree_type=forum`;
export const GET_NEWSPAPER_DATA = `${apiHost}${apiPath}newspaper/data`;
